import { useDispatch } from "react-redux";
import {
  getBlogSuccess,
  getCategory,
  getDataSuccess,
  getOneBlogSuccess,
  myBlogSuccess,
} from "../features/blogSlice";
import useAxios from "./useAxios";

const useBlogCalls = () => {
  const { axiosWithToken } = useAxios();
  const dispatch = useDispatch();

  const getData = async (url, page) => {
    try {
      const { data } = await axiosWithToken(`/${url}/?page=${page}&limit=4`);
      const apiData = data.data;
      dispatch(getBlogSuccess({ apiData, url }));
      // console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getCategoryName = async (url) => {
    try {
      const { data } = await axiosWithToken(`/${url}/`);
      const apiData = data.data;
      dispatch(getBlogSuccess({ apiData, url }));
      // console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getGeneralData = async () => {
    try {
      const { data } = await axiosWithToken("/blogs/");
      const apiData = data.data;
      dispatch(getDataSuccess(apiData));
      // console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getMyBlog = async (id) => {
    try {
      const { data } = await axiosWithToken(`/blogs?author=${id}`);
      dispatch(myBlogSuccess(data));
    } catch (error) {
      console.log(error);
    }
  };
  const getCategoryData = async (url, filter) => {
    try {
      const { data } = await axiosWithToken(`/${url}/filter[${filter}]`);
      const apiData = data.data;
      dispatch(getCategory({ apiData }));
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getOneData = async (url, idx) => {
    try {
      const { data } = await axiosWithToken(`/${url}/${idx}`);

      dispatch(getOneBlogSuccess(data));
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const postBlog = async (blog) => {
    try {
      await axiosWithToken.post("/blogs/", blog);
      getData("blogs");
    } catch (error) {
      console.log(error);
    }
  };
  const putBlog = async (blog, id) => {
    try {
      await axiosWithToken.put(`/blogs/${id}`, blog);
      console.log("put oldu");
      // getData("blogs");
    } catch (error) {
      console.log(error);
    }
  };
  const deleteBlog = async (id) => {
    try {
      await axiosWithToken.delete(`/blogs/${id}`);
      await getGeneralData();
    } catch (error) {
      console.log(error);
    }
  };
  const postLikeBlog = async (id) => {
    try {
      await axiosWithToken.post(`/blogs/${id}/postlike`);
      console.log("like verildi alındı");
      getOneData("blogs", id);
      getData("blogs");
    } catch (error) {
      console.log(error);
    }
  };

  const postComment = async (comment, id) => {
    try {
      await axiosWithToken.post(`/comments/`, comment);

      getOneData("blogs", id);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    getMyBlog,
    deleteBlog,
    getData,
    postBlog,
    getOneData,
    postLikeBlog,
    postComment,
    getCategoryData,
    putBlog,
    getCategoryName,
    getGeneralData,
  };
};

export default useBlogCalls;
